import { join } from 'light-component';
import { Box } from '@common';
import * as Base from '@base';
import { Highlighter } from '../../component';
import styles from '../style.module.less';
import type { ReactElement } from 'react';
import type { NumberProps } from './types';

export function NumberViewMode(props: NumberProps): ReactElement {
  return (
    <Box className={styles.viewBox}>
      <Box className={join(styles.subject, styles.input)}>
        <Highlighter
          title={props.title}
          keyword={props.keyword}
          className={styles.title}
        />
      </Box>
      <Box className={join(styles.content, styles.inputContent)}>
        <Base.InputNumber
          style={{ width: '100%' }}
          value={props.value}
          readOnly
        />
      </Box>
    </Box>
  );
}
